var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 80",
    style: {
      enableBackground: "new 0 0 79 80"
    },
    xmlSpace: "preserve",
    width: 79,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4,40.1c0-4.3-3.5-7.9-7.8-7.9c-4.3,0-7.9,3.5-8,7.8c-0.1,4.3,3.5,7.9,7.8,7.9 C43.8,47.9,47.3,44.5,47.4,40.1 M55.2,27.1c0,1.5-1.2,2.8-2.7,2.8c-1.6,0-2.8-1.2-2.8-2.8c0-1.6,1.2-2.8,2.8-2.8 C54,24.4,55.2,25.6,55.2,27.1 M51.8,40c0,6.8-5.4,12.3-12.1,12.3c-6.9,0-12.4-5.4-12.4-12.2c0-6.8,5.5-12.3,12.3-12.3 C46.2,27.7,51.8,33.2,51.8,40 M59.5,50.5c0-6.9,0-13.9,0-20.8c0-5.3-3.9-9.2-9.2-9.2c-3.6,0-7.2,0-10.8,0c-3.6,0-7.3,0-10.9,0 c-5.1,0-9,3.8-9.1,8.9c-0.1,7.1-0.1,14.3,0,21.4c0.1,5,3.9,8.8,8.9,8.8c7.4,0.1,14.7,0.1,22.1,0C55.7,59.5,59.5,55.6,59.5,50.5  M63.9,51.2c0,6.9-5.8,12.6-12.6,12.6c-3.9,0-7.9,0-11.8,0c-3.9,0-7.7,0-11.6,0c-7,0-12.7-5.7-12.8-12.7c0-7.4,0-14.8,0-22.3 c0-6.7,5.4-12.5,12.1-12.6c8.2-0.2,16.5-0.2,24.7,0c6.5,0.1,11.9,6,11.9,12.5C63.9,36.3,63.9,43.7,63.9,51.2 M78.5,69.7V10.3 c0-5.5-4.4-9.9-9.8-9.9H10.2c-5.4,0-9.8,4.4-9.8,9.9v59.4c0,5.5,4.4,9.9,9.8,9.9h58.5C74.1,79.6,78.5,75.1,78.5,69.7",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.81007ed00e614c78e435fc9c8c83ffdf.svg";
export { ForwardRef as ReactComponent };